import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { Button, Modal, Row, Col, Form, OverlayTrigger } from "react-bootstrap";
import { MdEdit, MdAddCircle, MdFilterList, MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import AppDataGrid from "../../components/common/AppDataGrid";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Tooltip } from '@mui/material';
import loading from "../../assets/images/common/loading.gif";

const Departments = () => {
    const userData = sessionStorage.getItem('user');
    const userObj = userData ? JSON.parse(userData) : {};
    const [Departments, setDepartments] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const navigate = useNavigate();
    const [showFilterModal, setShowFilterModal] = useState(false);
    const handleCloseFilterModal = () => setShowFilterModal(false);
    const handleShowFilterModal = () => setShowFilterModal(true);
    const [isLoading, setIsLoading] = useState(true);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const [filter, setFilter] = useState({
        dept_name: "",
        action: "FILTER"
    });

    const handleEditClick = (dept_id) => {
        const employeemasterToEdit = Departments.find(departments => departments.dept_id === dept_id);

        if (employeemasterToEdit) {
            navigate("/AddDepartments", { state: { departmentsData: employeemasterToEdit } });
        } else {
            console.error(`User with ID ${dept_id} not found.`);
        }
    };

    const fetchDepartments = async () => {
        try {
            const response = await axios.post(baseUrl + "/department/", {
                action: "READ",
                school_id: userObj.school_id
            });
            setDepartments(response.data);
        } catch (error) {
            console.error("Error fetching departments:", error);
        }
    };

    useEffect(() => {
        setIsLoading(true);
        fetchDepartments().finally(() => setIsLoading(false));
    }, []);

    const searchableColumns = [
        (row) => row.dept_name,
        (row) => row.is_active,
    ];

    const filteredRecords = (Departments || []).filter((item) =>
        searchableColumns.some((selector) => {
            const value = selector(item);
            const stringValue = String(value || '').toLowerCase().replace(/[-\s]+/g, '');
            const normalizedQuery = searchQuery.toLowerCase().replace(/[-\s]+/g, '');
            return stringValue.includes(normalizedQuery);
        })
    );

    const columns = [
        {
            field: "dept_name",
            headerName: "Department",
            flex: 1,
            sortable: true,
            renderCell: (params) => (
                <Tooltip title={params.value || ""}>
                    <span>{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: "is_active",
            headerName: "Status",
            flex: 1,
            sortable: true,
            renderCell: (params) => (
                <Tooltip title={params.value || ""}>
                    <span>{params.value}</span>
                </Tooltip>
            ),
        },
        ...(filteredRecords.length > 0
            ? [
                {
                    field: "actions",
                    headerName: "Actions",
                    flex: 1,
                    sortable: false,
                    renderCell: (params) => (
                        <div className="tableActions">
                            <Tooltip title="Edit" arrow>
                                <span
                                    className="commonActionIcons"
                                    onClick={() => handleEditClick(params.row.dept_id)}
                                >
                                    <MdEdit />
                                </span>
                            </Tooltip>
                            <Tooltip title="Delete" arrow>
                                <span
                                    className="commonActionIcons"
                                    onClick={() => handleDeleteClick(params.row.dept_id)}
                                >
                                    <MdDelete />
                                </span>
                            </Tooltip>
                        </div>
                    ),
                },
            ]
            : []),
    ];

    const handleDeleteClick = async (dept_id) => {
        const confirmDelete = window.confirm('Are you sure you want to change the status?');

        if (!confirmDelete) {
            return;
        }
        const requestBody = {
            dept_id: dept_id,
            action: "DELETE"
        };
        try {
            const response = await axios.post(baseUrl + '/department/', requestBody, {
                headers: {
                    'Content-Type': 'application/json'
                },
            });
            if (response.status < 200 || response.status >= 300) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            toast.success("Record Set to InActive");
            fetchDepartments();
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const handleFilterSubmit = async (e) => {
        e.preventDefault();

        const formData = {
            dept_name: filter.dept_name || "",
            action: "FILTER",
        };
        try {
            const response = await axios.post(baseUrl + "/department/", formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            const dataArray = Array.isArray(response.data) ? response.data : [];
            setDepartments(dataArray);
            setFilter((prevFilter) => ({
                ...prevFilter,
            }));
            setShowFilterModal(false);

        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleReset = async (e) => {
        e.preventDefault();
        setFilter({
            dept_name: "",
        });
        setShowFilterModal(true);
        fetchDepartments("/role");
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    return (
        <div className="pageBody">
            <ToastContainer />

            <div className="commonDataTableHead">
                <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                        <h6 className="commonTableTitle">Departments </h6>
                    </div>
                    <div className="">
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            className="searchInput"
                            onChange={handleSearchChange}
                        />
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: 6 }}>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Filter</Tooltip>}>
                            <Button className="secondaryBtn" variant="secondary" onClick={handleShowFilterModal}>
                                <MdFilterList />
                            </Button>
                        </OverlayTrigger>

                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Add</Tooltip>}>
                            <Button className="primaryBtn" variant="primary" onClick={() => navigate("/AddDepartments")}>
                                <MdAddCircle />
                            </Button>
                        </OverlayTrigger>
                    </div>
                </div>
            </div>
            <div className="commonTable height100">
                <div className="tableBody">
                    {isLoading ? (
                        <div className="loadingContainer">
                            <img src={loading} alt="Loading..." className="loadingGif" />
                        </div>
                    ) : (
                        <AppDataGrid
                            rows={Array.isArray(filteredRecords) ? filteredRecords : []}
                            columns={columns}
                            getRowId={(row) => row.dept_id || Math.random()}
                            showToolbar={false}
                            pagination={
                                Array.isArray(filteredRecords) && filteredRecords.length > 0
                            }
                            pageSizeOptions={[10, 20, 50]}
                            density="compact"
                            sx={{
                                maxHeight: 600,
                            }}
                        />
                    )}
                </div>
            </div>

            <Modal show={showFilterModal} onHide={handleCloseFilterModal} className="commonFilterModal">
                <Modal.Header closeButton className="modalHeaderFixed">
                    <Modal.Title>Filter</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modalBodyScrollable">
                    <Form id="filterForm" onSubmit={handleFilterSubmit}>
                        <Row>
                            <Col xs={12}>
                                <div className='commonInput'>
                                    <Form.Group controlId="firstName">
                                        <Form.Label>Department </Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="dept_name"
                                            name="dept_name"
                                            placeholder="Enter Department "
                                            maxLength={30}
                                            value={filter.dept_name}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/[^A-Za-z]/g, '');
                                                setFilter({ ...filter, dept_name: value });
                                            }}
                                        />
                                    </Form.Group>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="modalFooterFixed">
                    <Button variant="secondary" className="btn-info clearBtn me-2" onClick={handleReset}>
                        Reset
                    </Button>
                    <div>
                        <Button variant="secondary" className="btn-danger secondaryBtn me-2" onClick={handleCloseFilterModal}>
                            Cancel
                        </Button>

                        <Button variant="primary" className="btn-success primaryBtn" onClick={handleFilterSubmit}>
                            Search
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Departments;
